import { NominationProgress } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationProgress: (
  fetchContext: FetchContext,
  nominationId: number,
  nominationProgress: NominationProgress,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, nominationProgress, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/progress`, {
    method: 'PUT',
    body: JSON.stringify(nominationProgress),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination progress'));
